import Handsontable from 'handsontable/base';
import { Selection } from 'handsontable/plugins/contextMenu/contextMenu';

import { CellSelections } from '../../../../../../common/table/TableTypes';
import hyperFormulaInstance from '../../../manager/hyperFormulaInstance';
import { getAllCellsBetween } from '../../selectionUtils/tableSelectionGeometryUtils';
import { getHotTableCellData } from '../meta/hotTableCellMetaUtils';

/**
 * Logs the current Handsontable instance for table debugging.
 */
export function debugTableInstance(this: Handsontable): void {
    console.info(this);
}

/**
 * Logs the selected cells and formula-engine state for the current Handsontable selection.
 */
export const debugTableCell = (elementId: string) => {
    return function (this: Handsontable, key: string, selection: Selection[], clickEvent: MouseEvent): void {
        const cellSelections: CellSelections = selection.map(({ start, end }) => [
            start.row,
            start.col,
            end.row,
            end.col,
        ]);

        getAllCellsBetween(cellSelections).forEach(({ row, col }) => {
            const sheet = hyperFormulaInstance.getSheetId(elementId);

            const formulaInfo =
                sheet === undefined
                    ? {}
                    : {
                          hfCellValue: hyperFormulaInstance.getCellValue({ sheet, row, col }),
                          hfCellType: hyperFormulaInstance.getCellType({ sheet, row, col }),
                          hfCellValueType: hyperFormulaInstance.getCellValueType({ sheet, row, col }),
                          hfCellValueDetailedType: hyperFormulaInstance.getCellValueDetailedType({ sheet, row, col }),
                      };

            console.info({
                row,
                col,
                cellData: getHotTableCellData(this, { row, col }),
                ...formulaInfo,
            });
        });
    };
};
